module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "el"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseMap"
    }
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseMap"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3249e56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BootstrapPanel.vue
// module id = 513
// module chunks = 2